import { useState, Dispatch, SetStateAction, useEffect } from 'react'
import { useDebounce } from './use-debounce'

// TODO: Refactor params to be an object (delay, onDebounce)
export function useStateWithDebounce<T>(
    initialState: T,
    delay: number = 500,
    onDebounce?: (state: T) => void,
): [T, Dispatch<SetStateAction<T>>, T] {
    const [state, setState] = useState<T>(initialState)

    const debouncedState = useDebounce(state, delay)

    useEffect(() => {
        onDebounce?.(debouncedState)
    }, [debouncedState])

    return [
        state as T,
        setState as Dispatch<SetStateAction<T>>,
        debouncedState as T,
    ]
}
